function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { createContext } from '@chakra-ui/react-utils';
import { useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var [NavbarContextProvider, useNavbarContext] = createContext({
  name: 'NavbarContext'
});
var defaultKey = '';

var NavbarProvider = props => {
  var [activeKey, _setActiveKey] = useState(defaultKey);
  var value = useMemo(() => ({
    activeKey,
    setActiveKey: newKey => _setActiveKey(prevKey => prevKey !== newKey ? newKey : defaultKey)
  }), [activeKey]);
  return /*#__PURE__*/_jsx(NavbarContextProvider, _extends({}, props, {
    value: value
  }));
};

export { NavbarProvider, useNavbarContext };
//# sourceMappingURL=NavbarContext.js.map